import React from 'react'
import {
  IconBracelet,
  IconDiamond,
  IconEarring,
  IconLadiesWatch,
  IconMensWatch,
  IconNecklace,
  IconPocketWatch,
  IconSterlingSilver,
  IconGeneric,
  IconWatchStrap,
  IconRing,
  IconSet,
  IconPins,
  IconCufflinks,
  IconGlasses,
} from '../components/products/IconsProductPreloader'
import { IconPen } from '../components/Icons'

export const GetIcon = (type, flashing = true, className = '') => {
  let Icon = <IconGeneric flashing={flashing} className={className} />
  switch ((type || '').toLowerCase()) {
    case 'gia diamond':
    case 'diamond':
      Icon = <IconDiamond flashing={flashing} className={className} />
      break
    case 'bracelet':
      Icon = <IconBracelet flashing={flashing} className={className} />
      break
    case 'earring':
      Icon = <IconEarring flashing={flashing} className={className} />
      break
    case 'ring':
      Icon = <IconRing flashing={flashing} className={className} />
      break
    case 'cufflinks':
      Icon = <IconCufflinks flashing={flashing} className={className} />
      break

    case 'ladies watch':
    case 'ladies-watch':
      Icon = <IconLadiesWatch flashing={flashing} className={className} />
      break
    case 'jewelry set':
      Icon = <IconSet flashing={flashing} className={className} />
      break
    case 'pins':
      Icon = <IconPins flashing={flashing} className={className} />
      break

    // case 'pen/pencil':
    //   Icon = <IconPen flashing={flashing} className={className} />
    //   break
    case 'watch':
    case 'mens watch':
    case 'mens-watch':
      Icon = <IconMensWatch flashing={flashing} className={className} />
      break
    case 'necklace':
      Icon = <IconNecklace flashing={flashing} className={className} />
      break
    case 'glasses':
      Icon = <IconGlasses flashing={flashing} className={className} />
      break
    case 'pocket watch':
      Icon = <IconPocketWatch flashing={flashing} className={className} />
      break
    case 'sterling silver':
    case 'sterling-silver':
    case 'silver':
      Icon = <IconSterlingSilver flashing={flashing} className={className} />
      break
    case 'watch band':
    case 'watch-band':
    case 'band':
    case 'watch strap':
    case 'watch-strap':
    case 'strap':
      Icon = <IconWatchStrap flashing={flashing} className={className} />
      break
  }
  return Icon
}

const IconLoaders = ({
  type = 'bracelet',
  className = '',
  flashing = true,
  iconClassName = '',
}) => {
  return <div className={className}>{GetIcon(type, flashing, iconClassName)}</div>
}

export default IconLoaders
